import useMarkActivityKeyAsRead from './druid/providers/ActivityAcknowledgement/useMarkActivityKeyAsRead';

export default useMarkActivityKeyAsRead;
